export default "__VITE_ASSET__CeHSY_UO__"